import { useState, useEffect, useRef } from 'react'
import { Flex, Box, Text, Heading, Card, Button } from 'rebass/styled-components'
import { IGetHelpscoutTagsListInput, IGetHelpscoutTagsListOutput, ITagExpanded, IThreadOutput } from '../../../graphql/types/queries/conversation';
import { gql, useMutation, useQuery } from '@apollo/client';
import { GET_CONVERSATION_BY_ID, GET_HS_TAGS_LIST } from '../../../graphql/queries';
import PleaseWait from '../../../components/PleaseWait';
import { parseStringify } from '../../../utils/StringUtils';
import styled from 'styled-components';
import TextInput, { InputNoForm } from '../../../components/TextInput';
import { IOkPayload } from '../../../graphql/types/mutations/generics';
import { toast } from 'react-toastify';

const SAVE_TAGS = gql`
mutation setConvoTags($conversationId: String!, $tags: [String]!){
  setConvoTags(conversationId:$conversationId, tags:$tags) {
    ok
  }
}
`
interface ISaveTagsOutput {
  setConvoTags: IOkPayload
}

interface ISaveTagsInput {
  conversationId: string,
  tags: string[]
}

const TagWrap = styled(Flex)`
  border-radius: 12px;
  padding: 8px 12px;
  transition: all 0.3s ease;
  cursor: pointer;
`

const Wrapper = styled(Flex)`
  overflow: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

interface IConvoTaggingProps {
  convo: IThreadOutput
  close: ()=>void
}

const Tag: React.FC<{
  tag: ITagExpanded,
  isUsed?: boolean
  onRemove: () => void
  onAdd: () => void
  isRemoved?: boolean
  isAdded?: boolean
}> = ({ tag, onAdd, onRemove, isUsed, isRemoved, isAdded }) => {
  return (
    <TagWrap style={{
      border: `1px solid ${tag.color !== 'none' ? tag.color : 'rgb(52, 79, 121)'}`,
      background: (!isRemoved && !!isUsed) ? 'rgb(52, 79, 121)' : (isAdded && !isUsed) ? 'rgb(52, 79, 121)' : 'transparent'

    }} mr={4} mb={4}
      onClick={() => {
        if ((!isUsed && (isRemoved || !isAdded)) || (isUsed && isRemoved)) {
          onAdd()
        } else {
          onRemove()
        }
      }}>
      <Text style={{ userSelect: 'none' }} color={(!isRemoved && !!isUsed) ? 'white' : (isAdded && !isUsed) ? 'white' : 'rgb(52, 79, 121)'}>{tag.name}</Text>
      {/* {(!isUsed && (isRemoved || !isAdded)) || (isUsed && isRemoved) ? (
        <i className="fa fa-square-plus" onClick={onAdd}></i>
      ) : (
        <i className="fa fa-square-minus" onClick={onRemove}></i>
      )} */}
    </TagWrap>
  )
}

export const ConvoTagging: React.FC<IConvoTaggingProps> = ({ convo,close }) => {
  const [list, setList] = useState<ITagExpanded[]>([])
  const [save, { loading: isSaving }] = useMutation<ISaveTagsOutput, ISaveTagsInput>(SAVE_TAGS, {
    refetchQueries: [{
      query: GET_CONVERSATION_BY_ID,
      variables: {
        conversationId: convo.id.toString()
      }
    }],
    awaitRefetchQueries: true,
    onCompleted: (e) => {
      toast.success('Tags Updated Successfully', {
        autoClose: 5000
      })
      close()
    },
    onError: () => {
      toast.error('An error occured saving tags', {
        autoClose: 5000
      })
    }
  })
  const { data, loading, error } = useQuery<IGetHelpscoutTagsListOutput, IGetHelpscoutTagsListInput>(GET_HS_TAGS_LIST, {
    onCompleted: e => {
      setList(parseStringify(e.getHelpscoutTagsList.tags))
    }
  })
  const [filter, setFilter] = useState<string>()
  const [toAdd, setToAdd] = useState<Array<ITagExpanded>>([])
  const [toRemove, setToRemove] = useState<Array<ITagExpanded>>([])
  const ref = useRef<any>()

  useEffect(() => {
    if (!loading && !!data) {
      if (ref && ref.current) {
        ref.current.focus()
      }
    }
  }, [loading, data])

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.focus()
    }
  }, [])

  const onSave = () => {
    const originals = convo.tags
    const toKeep = originals.filter(x => toRemove.findIndex(xx => xx.id === x.id) < 0)
    const toBeAdded = toAdd

    const finals = [...toKeep.map(x => x.tag), ...toBeAdded.map(x => x.name)]
    save({
      variables: {
        conversationId: convo.id.toString(),
        tags: finals || []
      }
    })
  }

  return (
    <Flex flexDirection={'column'} overflow={'hidden'} flex={1}>
      <Heading mb={4} textAlign={'center'}>Add/Remove Conversation Tags</Heading>
      {!isSaving && !loading && !error && !!list && <InputNoForm mb={4} style={{ borderRadius: 0, height: '28px', fontSize: '12px' }} inputRef={ref} type="text" placeholder="Type to filter"
        value={filter} onChange={(e: any) => setFilter(e.target.value)} />}
      {!!isSaving || !!loading || !!error || !list ? (
        <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
          <PleaseWait text={isSaving ? 'Saving Tags' : 'Loading Tags'} />
        </Flex>
      ) : (
        <Flex overflow={'hidden'} flexDirection={'column'}>
          <Flex overflow={'hidden'} flex={1}>
            <Wrapper flexWrap={'wrap'} mt={4} flex={1}>
              {list.filter(x => {
                if (!filter) return true

                return x.name.toLowerCase().replace(/ /g, '').indexOf(filter.replace(/ /g, '').toLowerCase()) > -1
              }).sort((a, b) => {
                const isUsedA = convo.tags.findIndex(x => x.id === a.id) > -1
                const isUsedB = convo.tags.findIndex(x => x.id === b.id) > -1
                if (isUsedA && !isUsedB) return -1
                if (!isUsedA && isUsedB) return 1

                if (a.name < b.name) return -1

                return 1
              }).map(x => {
                return <Tag
                  key={`tag${x.id}`}
                  tag={x}
                  isAdded={toAdd.findIndex(xx => xx.id === x.id) > -1}
                  isRemoved={toRemove.findIndex(xx => xx.id === x.id) > -1}
                  isUsed={convo.tags.findIndex(xx => xx.id === x.id) > -1}
                  onAdd={() => {
                    setToRemove((parseStringify(toRemove) as ITagExpanded[]).filter(xx => xx.id !== x.id))
                    if (convo.tags.findIndex(xx => xx.id === x.id) > -1) return
                    setToAdd([...parseStringify(toAdd), x])
                  }}
                  onRemove={() => {
                    setToAdd((parseStringify(toAdd) as ITagExpanded[]).filter(xx => xx.id !== x.id))
                    if (convo.tags.findIndex(xx => xx.id === x.id) < 0) return
                    setToRemove([...parseStringify(toRemove), x])
                  }} />
              })}
            </Wrapper>
          </Flex>
          <Flex pt={2} alignItems={'center'} justifyContent={'center'}>
            <Button variant={'pink'} mr={3} onClick={close}>Cancel</Button>
            <Button variant={'primary'} disabled={toAdd.length < 1 && toRemove.length < 1}
              onClick={onSave}>
              Continue (<span>
                <i className="fa fa-trash" style={{ color: 'white', fontSize: '12px' }}></i>
              </span> {toRemove.length}, <span><i className="fa fa-circle-plus" style={{ color: 'white', fontSize: '12px' }}></i></span> {toAdd.length})
            </Button>
          </Flex>
        </Flex>)}
    </Flex>);
}